import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import JsonServiceClient from 'bz-stores/lib/JsonServiceClient';
import AuthStore from 'bz-stores/lib/auth-store';
import history from 'bz-utilities/modules/networking/history/rr4';
import { Button, Field } from 'click-controls';
import { Spinimate } from 'click-controls/controls/transitions/spinimate';
import { Observer } from 'mobx-react';
import QueryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import CodeInput from 'react-code-input';
import type { IMfaSetupProps } from '.';
import { TwoFactorRequestCode, TwoFactorVerify } from '../../../../../shared/tm3-core/api.dtos';

export function SMS({ onSetupComplete }: IMfaSetupProps) {
  const hasMobile = !!AuthStore.user.mobileNumber;
  const { twoFactorAllowSms } = AuthStore.user;
  if (!twoFactorAllowSms) return null;
  const [code, setCode] = useState('');
  const [resend, setResend] = useState(0);
  const [isCorrect, setIsCorrect] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const onResend = useCallback(() => setResend(1 + resend), [resend]);
  const onRequestCode = useCallback(async () => {
    const req = new TwoFactorRequestCode();
    await new JsonServiceClient().post(req);
  }, [twoFactorAllowSms]);

  const onSubmitChallenge = useCallback(async () => {
    setIsChecking(true);
    const req = new TwoFactorVerify({ code });
    const { result } = await new JsonServiceClient().post(req);
    setIsChecking(false);

    setIsCorrect(result);
    if (!result) return;
    onSetupComplete();
  }, [code]);

  useEffect(() => {
    onRequestCode();
  }, [twoFactorAllowSms, resend]);
  useEffect(() => {
    if (code.length === 6) onSubmitChallenge();
  }, [code]);

  return (
    <div>
      <h4 className="mb-4 text-xl font-bold">Step 1 - Receive a code</h4>
      {!hasMobile && (
        <p>
          Your user record does not have a mobile number setup on it. Please add one to your
          account, or setup an alterative multi factor authentication method.
        </p>
      )}
      {hasMobile && (
        <>
          <Observer>
            {() => (
              <p>
                We've send a code to the mobile number on your user record (
                {AuthStore.user.mobileNumber}
                ). <a onClick={onResend}>Click here to resend.</a>
              </p>
            )}
          </Observer>

          <form id="form-login" className="mt-4" role="form" onSubmit={onSubmitChallenge}>
            <h4 className="mb-4 text-xl font-bold">Step 2 - Enter the code</h4>
            <div className="flex flex-row justify-center">
              <div className="flex flex-row justify-center">
                <CodeInput
                  fields={6}
                  name="Code"
                  inputMode="numeric"
                  onChange={(code) => {
                    setIsChecking(true);
                    setCode(code);
                  }}
                />
              </div>
              <Spinimate show={!isChecking && !!isCorrect}>
                <CheckCircleIcon className="h-12 stroke-emerald-500" />
              </Spinimate>

              <Spinimate show={!isChecking && !isCorrect}>
                <XCircleIcon className="h-12 stroke-rose-500" />
              </Spinimate>
            </div>
            <Button className="btn mt-8" onPress={onSubmitChallenge}>
              Continue
            </Button>
          </form>
        </>
      )}
    </div>
  );
}
